import { cn } from "./cn";
import { Logo } from "./logo";
import { UiLink } from "./router";

export function Brand({
  subtitle = "Account portal",
  href = "/",
  className,
}: {
  subtitle?: string | null;
  href?: string;
  className?: string;
}) {
  return (
    <UiLink
      href={href}
      className={cn("group flex items-center gap-3 rounded-field", className)}
    >
      <Logo className="size-9 transition-transform duration-200 ease-out-soft group-hover:scale-[1.04]" />
      <span className="min-w-0">
        <span className="block truncate font-display text-md font-bold tracking-[-0.01em] text-ink">
          Empite Suite
        </span>
        {subtitle ? (
          <span className="block truncate text-2xs font-medium text-ink-4">
            {subtitle}
          </span>
        ) : null}
      </span>
    </UiLink>
  );
}
